import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { FeatureErrorBoundary } from '../../../../core-components/theme/components/FeatureErrorBoundary';
import { SignedInSessionProvider, useKnownSession } from '../../../../session';
import { ALERTS_RETRY_MS } from '../../constants/inApp';

import { AppLanguageFollower } from './AppLanguageFollower';
import { InAppAlerts } from './InAppAlerts';
import { NotificationStream } from './NotificationStream';

const RetryAlertsLater: React.FC<{ onRetry: () => void }> = ({ onRetry }) => {
  useEffect(() => {
    const timer = window.setTimeout(onRetry, ALERTS_RETRY_MS);
    return () => window.clearTimeout(timer);
  }, [onRetry]);
  return null;
};

const retryLater = (reset: () => void): React.ReactNode => <RetryAlertsLater onRetry={reset} />;

const SignedInAlerts: React.FC = () => {
  const known = useKnownSession();
  const { pathname } = useLocation();
  if (known?.status !== 'signedIn') return null;
  // Rendered beside routes that are not signed-in ones, so it carries the person itself.
  return (
    <SignedInSessionProvider session={known}>
      <NotificationStream />
      <AppLanguageFollower />
      <FeatureErrorBoundary feature="close-the-loop-inapp" resetKeys={[pathname]} fallback={retryLater}>
        <InAppAlerts />
      </FeatureErrorBoundary>
    </SignedInSessionProvider>
  );
};

export const InAppAlertsRoute: React.FC = () => (
  <>
    <SignedInAlerts />
    <Outlet />
  </>
);
